import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly publicAttendanceRoutes = ['/fichajes'];
  private readonly changePasswordRoute = '/change-password';

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Promise<boolean | UrlTree> {
    if (this.isPublicRoute(state.url)) {
      return true;
    }

    const path = state.url.split('?')[0];

    return this.authService.ensureSession().then((valid) => {
      if (!valid) {
        return this.router.createUrlTree(['/login'], {
          queryParams: { returnUrl: state.url },
        });
      }

      // A user who still owes a password change may only reach the
      // change-password screen; everything else redirects there.
      if (this.authService.mustChangePassword()) {
        return path === this.changePasswordRoute
          ? true
          : this.router.createUrlTree([this.changePasswordRoute]);
      }

      // Conversely, once compliant the change-password route has nothing to do.
      if (path === this.changePasswordRoute) {
        return this.router.createUrlTree([this.authService.getDefaultRoute()]);
      }

      return true;
    });
  }

  private isPublicRoute(url: string): boolean {
    const path = url.split('?')[0];
    return this.publicAttendanceRoutes.some(
      (route) => path === route || path.startsWith(`${route}/`),
    );
  }
}
